import React from 'react'
import { Link } from 'react-router-dom';

const HeaderImage = () => {
  return (
    <div>
      <br />
      <div>
        <Link to='/'>
          <img
            style={{
              position: 'absolute',
              top: '28px',
              left: '6px',
              justifyContent: 'flex-start',
              display: 'flex',
              cursor: 'pointer',
            }}
            width='11%'
            className='hidden-mobile'
            src='https://res.cloudinary.com/chqbook/image/upload/q_auto/v1550643436/logos/final_logo_chqbook.png'
            alt='Chqbook Logo' />
        </Link>

        <img
          className='hidden-mobile'
          src='https://res.cloudinary.com/chqbook/image/upload/q_auto/v1551252668/root/Banner.svg'
          width='100%'
          alt='Chqbook Banner' />
      </div>
      <div>
        <Link to='/'>
          <img
            style={{
              position: 'absolute',
              top: '22px',
              left: '6px',
              justifyContent: 'flex-start',
              display: 'flex',
              cursor: 'pointer'
            }}
            width='23%'
            className='hidden-desktop'
            src='https://res.cloudinary.com/chqbook/image/upload/q_auto/v1550643436/logos/final_logo_chqbook.png'
            alt='Chqbook Logo' />
        </Link>
        <img
          width='100%'
          className='hidden-desktop'
          src='https://res.cloudinary.com/chqbook/image/upload/q_auto/v1551247989/root/chqbook_Banner_mobile.png'
          alt='Chqbook Banner' />
      </div>
    </div>
  );
}

export default HeaderImage;


// WEBPACK FOOTER //
// ./src/components/HeaderImage.js